export function normalizeForSnapshot(value, options = {}) {
  const ignoreKeys = options.ignoreKeys || [];
  const ignoreSet = new Set(ignoreKeys);

  const normalize = (input) => {
    if (input === null || input === undefined) {
      return input;
    }

    if (input instanceof Date) {
      return input.toISOString();
    }

    if (typeof File !== 'undefined' && input instanceof File) {
      return {
        __type: 'File',
        name: input.name,
        size: input.size,
        type: input.type,
        lastModified: input.lastModified,
      };
    }

    if (typeof Blob !== 'undefined' && input instanceof Blob) {
      return {
        __type: 'Blob',
        size: input.size,
        type: input.type,
      };
    }

    if (Array.isArray(input)) {
      return input.map(normalize);
    }

    if (typeof input === 'object') {
      return Object.keys(input)
        .filter((key) => !ignoreSet.has(key))
        .sort()
        .reduce((acc, key) => {
          acc[key] = normalize(input[key]);
          return acc;
        }, {});
    }

    return input;
  };

  return normalize(value);
}

export function createStableSnapshot(value, options = {}) {
  return JSON.stringify(normalizeForSnapshot(value, options));
}

let activeUnsavedChangesHandler = null;

export function registerUnsavedChangesHandler(handler) {
  activeUnsavedChangesHandler = handler;
}

export function clearUnsavedChangesHandler(handler) {
  if (!handler || activeUnsavedChangesHandler === handler) {
    activeUnsavedChangesHandler = null;
  }
}

export async function runUnsavedChangesHandler(to, from) {
  if (typeof activeUnsavedChangesHandler !== 'function') {
    return true;
  }

  return activeUnsavedChangesHandler(to, from);
}
